import { Helmet } from 'react-helmet-async';
import Footer from '../../../components/Footer/footer.component';
import FooterNew from '../../../components/Footer/section-footer';

const ReturnsCancellationPolicy = () => {
  return (
    <>
      <Helmet>
        <title> Returns & Cancellation Policy | Ahguide </title>
        <meta
          name="description"
          content="If, for any reason, You are not completely satisfied with a purchase
          We invite You to review our policy on refunds and returns."
        />
        <link
          rel="canonical"
          href="https://www.ahguide.in/returns-cancellation-policy"
        />
      </Helmet>
      <div className="section">
        <div className="container">
          <h2 className="heading-secondary">Returns and Cancellation Policy</h2>
          <p className="header-description">Last updated: August 28, 2022</p>
          <p className="header-description">
            If, for any reason, You are not completely satisfied with a purchase
            We invite You to review our policy on refunds and returns.
          </p>
          <p className="header-description">
            The following terms are applicable for any products that You
            purchased with Us.
          </p>
          <h3 className="heading-tertiary">Interpretation and Definitions</h3>
          <h3 className="heading-tertiary">Interpretation</h3>
          <p className="header-description">
            The words of which the initial letter is capitalized have meanings
            defined under the following conditions. The following definitions
            shall have the same meaning regardless of whether they appear in
            singular or in plural.
          </p>
          <h3 className="heading-tertiary">Definitions</h3>
          <p className="header-description">
            For the purposes of this Return and Refund Policy:
          </p>
          <ul className="policy-list">
            <li>
              <p>
                <strong>Company</strong> (referred to as either &quot;the
                Company&quot;, &quot;We&quot;, &quot;Us&quot; or &quot;Our&quot;
                in this Agreement) refers to A H GUIDE, New Bus Stand,Rampurhat,
                West Bengal, India 731224.
              </p>
            </li>
            <li>
              <p>
                <strong>Goods</strong> refer to the items offered for sale on
                the Service.
              </p>
            </li>
            <li>
              <p>
                <strong>Orders</strong> mean a request by You to purchase Goods
                from Us.
              </p>
            </li>
            <li>
              <p>
                <strong>Service</strong> refers to the Website.
              </p>
            </li>
            <li>
              <p>
                <strong>Website</strong> refers to Ahguide, accessible from{' '}
                <a
                  href="https://www.ahguide.in"
                  rel="external nofollow noopener"
                  target="_blank"
                >
                  https://www.ahguide.in
                </a>
              </p>
            </li>
            <li>
              <p>
                <strong>You</strong> means the individual accessing or using the
                Service, or the company, or other legal entity on behalf of
                which such individual is accessing or using the Service, as
                applicable.
              </p>
            </li>
          </ul>
          <h3 className="heading-tertiary">Your Order Cancellation Rights</h3>
          <p className="header-description">
            You are entitled to cancel(except Tution Fees) Your Order within 7
            days without giving any reason for doing so.
          </p>
          <p className="header-description">
            The deadline for cancelling an Order is 7 days from the date on
            which You received the Goods or on which a third party you have
            appointed, who is not the carrier, takes possession of the product
            delivered.
          </p>
          <p className="header-description">
            In order to exercise Your right of cancellation, You must inform Us
            of your decision by means of a clear statement. You can inform us of
            your decision by:
          </p>
          <ul className="policy-list">
            <li>
              <p>By email: support@ahguide.in</p>
            </li>
            <li>
              <p>
                By visiting this page on our website:{' '}
                <a
                  href="https://www.ahguide.in/returns-cancellation-policy"
                  rel="external nofollow noopener"
                  target="_blank"
                >
                  https://www.ahguide.in/returns-cancellation-policy
                </a>
              </p>
            </li>
            <li>
              <p>By phone number: 7098230513</p>
            </li>
          </ul>
          <p className="header-description">
            We will reimburse You no later than 14 days from the day on which We
            receive the returned Goods. We will use the same means of payment as
            You used for the Order, and You will not incur any fees for such
            reimbursement.
          </p>
          <h3 className="heading-tertiary">Conditions for Returns</h3>
          <p className="header-description">
            Items are returnable if you've received them in a condition that is
            -
          </p>
          <ul className="policy-list">
            <li>Physically damaged</li>
            <li>Defective</li>
            <li>
              Different from its description on the product detail page on
              Ahguide.in
            </li>
          </ul>
          <p className="header-description">
            In order for the Goods to be eligible for a return, please make sure
            that:
          </p>
          <ul className="policy-list">
            <li>The Goods were purchased in the last 7 days</li>
            <li>The Goods are in the original packaging</li>
          </ul>
          <p className="header-description">
            The following Goods cannot be returned:
          </p>
          <ul className="policy-list">
            <li>
              The supply of Goods made to Your specifications or clearly
              personalized.
            </li>
            <li>Payment done for Tution fees, Mock test.</li>
          </ul>
          <p className="header-description">
            We reserve the right to refuse returns of any merchandise that does
            not meet the above return conditions in our sole discretion.
          </p>
          <p className="header-description">
            Only regular priced Goods may be refunded. Unfortunately, Goods on
            sale cannot be refunded. This exclusion may not apply to You if it
            is not permitted by applicable law.
          </p>
          <h3 className="heading-tertiary">Returning Goods</h3>
          <p className="header-description">
            You are responsible for the cost and risk of returning the Goods to
            Us. You should send the Goods at the following address:
          </p>
          <p className="header-description">
            New Bus Stand,Rampurhat, India 7312234
          </p>
          <p className="header-description">
            We cannot be held responsible for Goods damaged or lost in return
            shipment. Therefore, We recommend an insured and trackable mail
            service. We are unable to issue a refund without actual receipt of
            the Goods or proof of received return delivery.
          </p>
          <h3 className="heading-tertiary">Gifts</h3>
          <p className="header-description">
            If the Goods were marked as a gift when purchased and then shipped
            directly to you, You'll receive a gift credit for the value of your
            return. Once the returned product is received, a gift certificate
            will be mailed to You.
          </p>
          <p className="header-description">
            If the Goods weren't marked as a gift when purchased, or the gift
            giver had the Order shipped to themselves to give it to You later,
            We will send the refund to the gift giver.
          </p>
          <h3 className="heading-tertiary">Contact Us</h3>
          <p className="header-description">
            If you have any questions about our Returns and Refunds Policy,
            please contact us:
          </p>
          <ul className="policy-list">
            <li>
              <p>By email: support@ahguide.in</p>
            </li>
            <li>
              <p>
                By visiting this page on our website:{' '}
                <a
                  href="https://www.ahguide.in/returns-cancellation-policy"
                  rel="external nofollow noopener"
                  target="_blank"
                >
                  https://www.ahguide.in/returns-cancellation-policy
                </a>
              </p>
            </li>
            <li>
              <p>By phone number: 7098230513</p>
            </li>
          </ul>
        </div>
      </div>
      <FooterNew />
    </>
  );
};

export default ReturnsCancellationPolicy;
